<template>
  <div class="next-section__outer">
    <component 
      :is="download ? 'a' : 'router-link'" 
      v-bind="attrs"
      @click="$emit('click')"
    >
      <div class="next-section anim anim-opacity-1" data-anim>
        <router-link :to="link" class="next-section__link-mob" v-if="!download"> </router-link>
        <div class="next-section__left">
          <span class="next-section__link">
            {{ subtitle ? subtitle : 'Следующий раздел' }}
          </span>
          <h3 class="next-section__title">{{ title }}</h3>

          <div v-if="!download" class="next-section__arrow">
            <svg width="201" height="20" viewBox="0 0 201 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M192.25 20L200.75 10.25L192.25 0.5L191 1.75L198.4 10.25L191 18.75L192.25 20Z" />
              <path d="M0 11L198.5 11L199 10.25L198.5 9.5L-6.55674e-08 9.49999L0 11Z" />
            </svg>
          </div>
          <div v-else class="next-section__download">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.5 0L15.5 25.002L16 25.5L16.5 25.002L16.5 -4.37112e-08L15.5 0Z" fill="#2E2E2E" />
              <path d="M7 19L16 26L25 19L24.5 18L16 24.5L7.5 18L7 19Z" fill="#2E2E2E" />
              <rect y="31" width="32" height="1" fill="#2E2E2E" />
            </svg>
          </div>
        </div>
        <div class="next-section__right">
          <img
            :src="image"
            alt=""
            class="next-section__img"
          />
          <img
            :src="imageMob || image"
            alt=""
            class="next-section__img-mob"
          />
        </div>
      </div>
    </component>

    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/common/Footer'
import anims from '@/mixins/anims'
import SvgUse from './SvgUse.vue'

export default {
  name: 'NextSection',

  props: ['title', 'subtitle', 'link', 'desc', 'image', 'imageMob', 'download'],

  components: {
    Footer,
    SvgUse
  },

  mixins: [anims],

  computed: {
    ...mapGetters('fullpage', {
      content: 'sectionsContent'
    }),

    showroom () {
      return this.content.contacts.footer
    },

    attrs () {
      const properties = {}

      if (this.download) {
        properties.download = this.link.replace('', '')
        properties.href = require(`@/assets/pdf/${this.link}`)
      } else {
        properties.to = this.link
      }

      return properties
    }
  }
}
</script>

<style lang="scss">
.next-section {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  @include max-width(mobile) {
    position: relative;
  }

  &:hover {
    .next-section__right img {
      transform: scale(1.05);
    }  
    @include min-width(tablet) {  
      .next-section__arrow svg {
        transform: translateX(0);
      }
    }
  }
  &__title {
    font-size: vw(30);
    line-height: vw(36);
    color: #2e2e2e;
    font-weight: 300;
    letter-spacing: 0.01em;
    margin-bottom: vw(31);
    transition: 0.25s ease 0s;
    @include max-width(mobile) {
      font-size: vwm(26);
      line-height: vwm(31);
      color: #fff;
      font-weight: 300;
      margin-bottom: vwm(22);
    }
  }
  &__link {
    display: inline-block;
    font-size: vw(17);
    margin-bottom: vw(31);
    color: #999;
    text-transform: uppercase;
    &-mob {
      display: none;
      @include max-width(mobile) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
      }
    }
    @include max-width(mobile) {
      font-size: vwm(12);
      line-height: vwm(14);
      text-decoration: none;
      margin-bottom: vwm(22);
      color: #fff;
      pointer-events: none;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }
  }
  &__desc {
    display: none;
    @include max-width(mobile) {
      display: block;
      font-family: "Helvetica";
      font-weight: 300;
      font-size: vw-m(22);
      line-height: vw-m(26);
      letter-spacing: 0.01em;
      color: #ffffff;
      text-transform: uppercase;
      margin-top: vw-m(11);
    }
  }
  &__download svg {
    path, rect {
      transition: all .3s ease 0s;

      @include max-width(mobile) {
        fill: #fff;
      }
    }
  }
  &__left {
    width: 50%;
    padding: vw(122) vw(67) vw(85) vw(125);
    @include max-width(mobile) {
      width: 100%;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      padding: vwm(50);
      text-align: center;
      z-index: 1;
    }

    &:hover {
      .next-section__title {
        color: rgba(0, 0, 0, 0.75);

        @include max-width(mobile) {
          color: #fff;
        }
      }
      .next-section__download svg path,
      .next-section__download svg rect {
        fill: rgba(0, 0, 0, 0.5);

        @include max-width(mobile) {
          fill: #fff;
        }
      }
    }
  }
  &__right {
    width: 50%;
    overflow: hidden;

    img {
      transition: transform 0.35s ease-out 0s;
    }
    @include max-width(mobile) {
      width: 100%;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }
  &__img {
    display: block;
    width: 100%;
    @include max-width(mobile) {
      display: none;
    }
    &-mob {
      display: none;
      @include max-width(mobile) {
        display: block;
      }
    }
  }
  &__arrow {
    width: vw(201);
    height: vw(20);
    overflow: hidden;

    svg {
      transform: translateX(vw(-80));
      width: vw(201);
      height: vw(20);
      fill: currentColor;
      will-change: transform;
      transition: transform 0.3s ease-out;
    }

    @include max-width(mobile) {
      width: vwm(126);
      height: vwm(18);
      margin: 0 auto;
      overflow: visible;

      svg {
        transform: none;
        color: #fff;
        width: vwm(126);
        height: vwm(18);
      }
    }
  }  
}
.full-section--footer {
  height: auto !important;
  max-height: vw(284);
  @include max-width(mobile) {
    max-height: none;
    min-height: auto;
  }
  .fs-contacts-footer {
    padding-left: vw(63);
    display: flex;
    justify-content: space-between;
    background: map-get($ui, semi-white-alt);
    flex: 0 0 vw(120);
    @include max-width(mobile) {
      padding-left: 0;
      flex: auto;
      flex-direction: column;
      background-color: #fff;
    }
    &-items {
      display: flex;
      flex-flow: row nowrap;
      height: 100%;
      min-height: vw(284);
      align-items: flex-end;
      padding-bottom: vw(26);
      width: vw(660);
      @include max-width(mobile) {
        flex-wrap: wrap;
        padding-left: vw-m(29);
        padding-right: vw-m(29);
        padding-bottom: vw-m(29);
        justify-content: space-between;
        width: 100%;
        min-height: auto;
      }
    }
    &-item {
      flex: 0 0 50%;
      margin-right: 0;
      @include max-width(mobile) {
        font-size: vw-m(15);
        text-transform: uppercase;
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-bottom: 0 !important;
        margin-right: 0 !important;
        flex: 0 0 auto;
        white-space: nowrap;
      }
      &:not(:nth-child(2)) {
        @include max-width(mobile) {
          padding-left: vw-m(30);
        }
      }
      &:nth-child(2) {
        @include max-width(mobile) {
          padding-left: vw-m(30);
        }
      }
      &:nth-child(2) {
        text-align: right;
        padding-right: vw(60);
        @include max-width(mobile) {
          padding-right: vw-m(30);
          text-align: left;
        }
      }
      &__title {
        font-weight: 500;
        font-size: vw(20);
        display: block;
      }
      &__content {
        font-size: vw(18);
        color: #141414;
        opacity: 0.5;
        display: block;
        margin: vw(8) 0;
        @include max-width(mobile) {
          font-size: vw-m(15);
        }
      }
    }
  }
  .fs-footer-social {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-right: vw(46);
    padding-bottom: vw(40);
    @include max-width(mobile) {
      justify-content: flex-end;
      order: -1;
      padding-top: vw-m(100);
      padding-bottom: vw-m(85);
    }
    &-item {
      &:not(:last-child) {
        margin-right: vw(46);
      }
      &--mobile {
        display: none;
        @include max-width(mobile) {
          display: list-item;
          margin-right: vw-m(36);
          a {
            display: block;
          }
          img {
            max-height: vw-m(42);
          }
        }
      }
      @include max-width(mobile) {
        display: none;
      }
    }
  }
}
</style>
